import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo } from 'react';
import { titleCell } from '../../../../components/elements/function';
import Icon from '../../../../components/icons';
import Loader from '../../../../components/loader';
import { useParams } from 'react-router-dom';
import { useDepreciationApi } from '../../../../store/api/hooks/depreciationApiHook';
import { DATE_FORMAT } from '../../../../_common/constant';
import moment from 'moment';
import Button from '../../../../components/elements/button';
import { useSagesApi } from '../../../../store/api/hooks/sageApiHook';
import toast from 'react-hot-toast';
import Currency from '../../../../components/currency';

interface Props {
  _ref: any,
  isDisposed?: boolean;
  hasPermission?: boolean;
  onSagePostSuccess?: () => void;
  onDisposalUpdate?: (disposalData: any) => void;
}


const GaapDepreciation: React.FC<Props> = ({ _ref, isDisposed, hasPermission = true, onSagePostSuccess, onDisposalUpdate }) => {
  const myTheme = themeQuartz.withParams({
    headerBackgroundColor: `#F0F0F0`
  });
  const theme = useMemo<Theme | "legacy">(() => {
    return myTheme;
  }, []);

  const params: any = useParams();
  const [rowData, setRowData] = React.useState<any[] | null>([]);
  const depreciationAPI = useDepreciationApi();
  const [loadingRowId, setLoadingRowId] = React.useState<string | null>(null);
  const sageApi: any = useSagesApi();
  const [disposalData, setDisposalData] = React.useState<any[] | null>([]);
  const columnDefs = [

    { headerName: 'Depreciation Date', field: 'deprciationDate', headerClass: 'bg-[#f0f0f0]', width: 190, cellRenderer: (data: any) => data.value ? moment(data.value).format(DATE_FORMAT) : '--' },
    /* { headerName: 'Asset Name', field: 'assetName', headerClass: 'bg-[#f0f0f0]', width: 370, cellRenderer: titleCell }, */
    { headerName: 'Cost Basis', field: 'costBasis', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 160, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
    { headerName: 'Opening Balance', field: 'purchaseCost', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 160, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
    { headerName: 'Current Month Depreciation', field: 'depriciationAmount', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 240, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
    { headerName: 'Accumulated Depreciation', field: 'accmAmount', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 210, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
    { headerName: 'Book Value', field: 'bookValueEnd', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 140, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
    //{ headerName: 'Closing Balance', field: 'bookValueEnd', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 140, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
    { headerName: 'Sage Doc No', field: 'sageDocNo', headerClass: 'bg-[#f0f0f0]', width: 190, cellRenderer: (data: any) => data.value ? data.value : '--' },
    { headerName: 'Sage Posting Date', field: 'sagePostingDate', headerClass: 'bg-[#f0f0f0]', minWidth: 190, flex: 1, cellRenderer: (data: any) => data.value ? moment(data.value).format(DATE_FORMAT) : '--' },
    {
      headerName: "Action",
      field: "sageDocument",
      headerClass: "bg-[#f0f0f0]",
      width: 160,
      cellRenderer: (params: any) => {
        const { sageDocNo, gaapDepreciationLogID, deprciationDate, isPushToSage } = params.data;

        const depreciationYear = deprciationDate ? moment(deprciationDate).year() : null;
        const currentYear = moment().year();

        // Check if asset is disposed with disposalTypeID == 2
        const isDisposedWithType2 = disposalData && disposalData.some((disposal: any) => 
          disposal.disposalTypeID === 2
        );
        const shouldDisableDiv = isDisposed && isDisposedWithType2;

        // Determine if button should be disabled
        let isDisabled;
        if (isPushToSage === 1) {
          // If isPushToSage is 1, always disable
          isDisabled = true;
        } else if (isPushToSage === 0) {
          // If isPushToSage is 0, check existing conditions
          isDisabled =
            shouldDisableDiv ||
            (!shouldDisableDiv && (
              !!sageDocNo ||
              loadingRowId === gaapDepreciationLogID ||
              depreciationYear !== currentYear ||
              !hasPermission
            ));
        } else {
          // Default behavior for other cases
          isDisabled =
            shouldDisableDiv ||
            (!shouldDisableDiv && (
              !!sageDocNo ||
              loadingRowId === gaapDepreciationLogID ||
              depreciationYear !== currentYear ||
              !hasPermission
            ));
        }

        console.log('hhhhhbbbb',{ isDisposed, isDisposedWithType2, shouldDisableDiv });

        return (
            <div className={`flex items-center justify-between`}>
            <Button
              onClick={() => postToSage(params.data)}
              disabled={isDisabled}
            >
              {sageDocNo
                ? "Posted"
                : loadingRowId === gaapDepreciationLogID
                  ? "Posting..."
                  : "Post To Sage"}
            </Button>

          </div>
        );
      },
    }

  ];

  const GetDisposalList = (assetID: any = params.id) => {
    const payload = {
      assetID: assetID,
    };
    depreciationAPI.GetDisposalList(
      payload,
      (data: any) => {
        setDisposalData(data.disposalList);
        // Callback to parent component if provided
        if (onDisposalUpdate) {
          onDisposalUpdate(data.disposalList);
        }
      },
      (error: any) => {
        console.error('Error fetching disposal list:', error);
      }
    );
  };

  const postToSage = (row: any) => {
    setLoadingRowId(row.gaapDepreciationLogID);
    const payload = {
      assetID: row.assetID,
      logID: row.gaapDepreciationLogID,
    };
    sageApi.PostAssetDepreciationToSage(
      payload,
      (resp: any) => {
        console.log("response =>", resp);
        setLoadingRowId(null);
        GetGAAPDepreciation();
        if (resp.successful) {
          toast.success(resp?.message);
          // Call the callback to reload accounting form
          if (onSagePostSuccess) {
            onSagePostSuccess();
          }
        } else {
          setLoadingRowId(null);
          toast.error(resp.message || "Connection Failed");
        }
      },
      (error: any) => {
        console.log("error =>", error);
        setLoadingRowId(null);
        toast.error(error);
      }
    );
  };


  const GetGAAPDepreciation = (assetID: any = params.id) => {
    console.log('Hooooooooooo==')
    const payload = {
      assetID: assetID,
    };
    depreciationAPI.GetGAAPDepreciation(
      payload,
      (data: any) => {
        setRowData(data.depreciationList);
      },
      (error: any) => { }
    );
  };

  useEffect(() => {
    if (params.id) {
      GetGAAPDepreciation(params.id);
      GetDisposalList(params.id);
    }
  }, [params]);

  /* useEffect(() => {
    if (_ref?.current) {
      _ref.current.reload = GetGAAPDepreciation
    }

  }, [_ref]); */
  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reload = () => {
        GetGAAPDepreciation();
        GetDisposalList();
      };
      _ref.current.getDisposalData = () => disposalData;
    }
  }, [_ref, disposalData]);

  return (
    <div ref={_ref}>
      <div className="flex items-center justify-between h-[60px]">
        <h4 className="font-semibold text-[0.938rem]">GAAP Depreciation</h4>
      </div>
      <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
        <AgGridReact
          theme={theme}
          columnDefs={columnDefs}
          rowData={rowData || []}
          pagination={false}
          domLayout="normal"
          ensureDomOrder={true}
          suppressHorizontalScroll={true}
          loadingOverlayComponent={Loader}
          noRowsOverlayComponent={() => (
            <div className="flex items-center justify-center h-full">
              <div className="text-center text-gray-500">
                <div className="text-lg font-medium">No Data Found</div>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default GaapDepreciation;